// Third Party
import React from 'react';

// Components
import Icon from '@/views/components/common/Icon';

type CollapsibleSectionProps = {
  title: string;
  summaryId?: string;
  children: React.ReactNode;
};

const CollapsibleSection = ({ title, summaryId, children }: CollapsibleSectionProps) => (
  <details className="collapsible-section">
    <summary className="collapsible-summary" id={summaryId}>
      <span>{title}</span>
      <Icon type="ds-arrow-drop-down" size={24} className="collapsible-summary-icon" decorative />
    </summary>
    <div className="collapsible-section-content">{children}</div>
  </details>
);

export default CollapsibleSection;
